import { ViewModel,View, ObservableArray } from "binder"
import { SelectorBaseViewModel } from "src/common/reusableComponents/selectorBase/selectorBase-viewModel";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { getAsNumber } from "src/uicomponents/components/utilities";
import { ServerSideDataLoader, PaginationInfo } from "uicomponents";
import { ProvinceSelectorViewModel } from "../provinceManipulation/provinceManipulation-viewModel";
import  { CityManipulationView } from "./cityManipulation-view"

export class CityManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'مدیریت شهرها ';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.city = ObservableArray.create<city>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new CityManipulationView();
    }
    public getTypeId(): string {
        return "VM-99092098-F1B7-423A-B034-A821D7CA704C"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set city(v: ObservableArray<city>) { this._city = v; } public get city(): ObservableArray<city> { return this._city;} private _city: ObservableArray<city>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetAllCity',{
                FilteringInformation:filteringInformation
            });
            let rowNumber = 1;
            this.city.update(...result.City.map(q=>{
                let r = new city(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.provinceId = q.ProvinceId;
                r.provinceName = q.ProvinceName;
                r.name = q.Name;            
                r.sortOrder = q.SortOrder;            
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
    async requestCityCreation(){
        let editor = new cityEditor(this,new InsertServerUpdater());
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
    
    async cityUpdater(city:city){
        let editor = new cityEditor(this,new UpdateServerUpdater());
        city.cloneTo(editor);
        let resultCode = await this.showPopup(editor);
        if(resultCode=='done'){
            this.loader.refresh();
        }
    }
}

export class city extends ViewModel{
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:CityManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.sortOrder = 1000;
        
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set sortOrder(v: number) { this._sortOrder = getAsNumber(v,true); } public get sortOrder(): number { return this._sortOrder;} private _sortOrder: number;
    
    public set provinceName(v: string) { this._provinceName = v; } public get provinceName(): string { return this._provinceName;} private _provinceName: string;
    public set provinceId(v: string) { this._provinceId = v; } public get provinceId(): string { return this._provinceId;} private _provinceId: string;
    
    private _typedParent:CityManipulationViewModel;

    cloneTo(city:city){
        city.id = this.id;
        city.name = this.name;
        city.sortOrder = this.sortOrder;
        city.setProvince(this.getProvinceId(), this.provinceName);
    }

    setProvince(id: string, name: string) {
        this.provinceId = id;
        this.provinceName = name;
    }
    getProvinceId() {
        return this.provinceId;
    }
    
    async edit(){
        this._typedParent.cityUpdater(this);
    }  
}

interface IServerUpdater{
    execute(city:city):Promise<void>;
    getSuccessMessage():string;
}

class InsertServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return ' شهر با موفقیت ثبت شد.';
    }
    async execute(city: city): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/CreateCity',{
            Province:city.getProvinceId(),
            Name:city.name,
            SortOrder:city.sortOrder
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

class UpdateServerUpdater implements IServerUpdater{
    getSuccessMessage(): string {
        return 'شهر با موفقیت به روز رسانی شد.';
    }
    async execute(city: city): Promise<void> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/UpdateCity',{
            Id:city.id,
            Province:city.getProvinceId(),
            Name:city.name,
            SortOrder:city.sortOrder?? 0
        });
        if(result.IsSuccessful==false){
            throw "new Error";
        }
    }
}

export class cityEditor extends city implements IPopup{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    constructor(parent:CityManipulationViewModel,serverUpdater:IServerUpdater) {
        super(parent);
        this._serverUpdater = serverUpdater;
        this.provinceSelector = new ProvinceSelectorViewModel(this);
    }
    closePopup(resultCode: string = null) {
    }
    
    private _serverUpdater:IServerUpdater;
    public set provinceSelector(v: ProvinceSelectorViewModel) { this._provinceSelector = v; } public get provinceSelector(): ProvinceSelectorViewModel { return this._provinceSelector;} private _provinceSelector: ProvinceSelectorViewModel;
    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    verify():string[]{
        let result :string[] =[];
        if(stringIsNullOrEmpty(this.name)){
            result.push(' نام شهر مشخص نشده است.')
        }
        if(stringIsNullOrEmpty(this.getProvinceId())){
            result.push(' استان مشخص نشده است.')
        }
        return result;
    }

    setProvince(id: string, name: string) {
        this.provinceSelector.selectById(id);
    }

    getProvinceId() {
        return this.provinceSelector.selectedItem?.id;
    }
    
    async save(){
        try {
            let verificationResult = this.verify();
            if(verificationResult.length>0){
                let errorMessage = verificationResult.join('\n');
                await this.messageBoxConfirmWarning(errorMessage,'عدم امکان ثبت شهر');
                return;
            }
            this.isLoading = true;
            await this._serverUpdater.execute(this);
            await this.messageBoxConfirmSuccess(this._serverUpdater.getSuccessMessage(),'عملیات موفق');
            this.closePopup("done")
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
    }

    back(){
        this.closePopup();
    }

}

export class CitySelectorViewModel extends SelectorBaseViewModel<cityForSelector>{
    public set provinceId(v: string) {
        this._provinceId = v; 
        this.refresh();    
    } public get provinceId(): string { return this._provinceId;} private _provinceId: string;
    
    protected async loadData(): Promise<cityForSelector[]> {
        let result = await ServerConnection.callServer('/Complex/EnterpriseAdministrationServices/GetCityByProvinceId',{
            ProvinceId: this.provinceId
        });
        return result.City.map(q=>{
            let result = new cityForSelector(this);
            result.id = q.Id;
            result.title = q.Name;
            return result;
        });
    }

}

class cityForSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);   
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
}
